import {
  deleteGroup as deleteGroupKey,
  groupedPresets,
} from 'components/Presets/data/queryKeyFactory';
import { deleteGroup } from 'components/Presets/sources/presets';

import { ConfirmDialog } from '@gogame/components';
import { useMutation, useQueryClient } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

export const useDeleteGroup = (presetKey) => {
  const showModalDeleteModal = useScreenModalV2(ConfirmDialog);
  const queryClient = useQueryClient();
  const deleteMutation = useMutation(
    deleteGroupKey(presetKey),
    (group) =>
      deleteGroup({
        id: group.id,
        screen: presetKey,
      }),
    {
      successMessage: () => 'Preset group deleted',
      onMutate: async (groupToRemove) => {
        try {
          queryClient.setQueriesData(
            {
              queryKey: groupedPresets({}),
              exact: false,
            },
            (previousPresets) => {
              const result = previousPresets?.my?.filter((group) => {
                return group?.id !== groupToRemove.id;
              });

              return { ...previousPresets, my: result };
            }
          );
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('delete group', e);
        }
      },
    }
  );

  const handleAction = async (group) => {
    await showModalDeleteModal({
      title: `Delete Group?`,
      confirmActionLabel: 'Delete',
      bodyText: `"${group.name}" and all of its presets will be deleted permanently`,
    });
    deleteMutation.mutateAsync(group);
  };
  return [handleAction, deleteMutation];
};
